import remark from "remark";
import remarkLint from "remark-preset-lint-recommended";
import remarkHtml from "remark-html";

export const processMarkdown = (md) => {
  const file = remark().use(remarkLint).use(remarkHtml).processSync(md);

  const html = String(file);

  // The weird regex below just escapes two forward slashes "//" which
  // we use to insert new paragraphs. We have to use a global regex here
  // because String.replaceAll is still not widely supported in JavaScript
  // and using a global regex with .replace is the other method of doing it
  return html.replace(/\/\//g, "</p><p>");
};
